<script>
import ModalStudentSimulatorComponent from '../features/ModalStudentSimulatorComponent';

export default {
  name: 'ModalStudentSimulatorView',
  extends: ModalStudentSimulatorComponent,
  computed: {
    currentTimerMode() {
      if (!this.formData.isTimer) return 'none';
      if (this.formData.timerType?.id === 1) return 'general';
      if (this.formData.timerType?.id === 2) return 'section';
      if (this.formData.timerType?.id === 3) return 'question';
      return 'general';
    },
    currentPresets() {
      if (this.isTestTimeType) {
        return [
          { label: '30 seg', value: 30 },
          { label: '45 seg', value: 45 },
          { label: '60 seg', value: 60, tag: 'Estándar' },
          { label: '90 seg', value: 90 },
          { label: '120 seg', value: 120 },
        ];
      }
      return [
        { label: '30 min', value: 30 },
        { label: '45 min', value: 45 },
        { label: '60 min', value: 60, tag: 'Recomendado' },
        { label: '90 min', value: 90 },
        { label: '120 min', value: 120 },
        { label: '180 min', value: 180 },
      ];
    },
  },
  methods: {
    selectTimerMode(mode) {
      if (mode === 'none') {
        this.formData.isTimer = false;
        this.formData.timerType = null;
        this.formData.duration = null;
        this.isTestTimeType = false;
        return;
      }
      this.formData.isTimer = true;
      if (mode === 'general') {
        const type = (this.timerTypes && this.timerTypes.find(t => t.id === 1)) || { id: 1, name: 'General' };
        this.formData.timerType = type;
        this.isTestTimeType = false;
        if (!this.formData.duration || this.formData.duration <= 0) {
          this.formData.duration = 60;
        }
      } else if (mode === 'section') {
        const type = (this.timerTypes && this.timerTypes.find(t => t.id === 2)) || { id: 2, name: 'Sección' };
        this.formData.timerType = type;
        this.isTestTimeType = false;
        if (!this.formData.duration || this.formData.duration <= 0) {
          this.formData.duration = 30;
        }
      } else if (mode === 'question') {
        const type = (this.timerTypes && this.timerTypes.find(t => t.id === 3)) || { id: 3, name: 'Por Pregunta' };
        this.formData.timerType = type;
        this.isTestTimeType = true;
        if (!this.formData.duration || this.formData.duration <= 0) {
          this.formData.duration = 60;
        }
      }
    },
    setDuration(val) {
      this.formData.duration = val;
    },
    incrementDuration(step = 5) {
      const current = Number(this.formData.duration) || 0;
      const max = this.isTestTimeType ? 300 : 360;
      this.formData.duration = Math.min(current + step, max);
    },
    decrementDuration(step = 5) {
      const current = Number(this.formData.duration) || 0;
      const min = 1;
      this.formData.duration = Math.max(current - step, min);
    },
    setQuestionQuantity(row, qty) {
      row.questionQuantity = qty;
    },
    incrementQuestions(row, step = 1) {
      const current = Number(row.questionQuantity) || 0;
      row.questionQuantity = Math.min(current + step, 200);
    },
    decrementQuestions(row, step = 1) {
      const current = Number(row.questionQuantity) || 0;
      row.questionQuantity = Math.max(current - step, 1);
    },
  },
};
</script>

<template>
  <el-dialog
    v-model="conf.isVisible"
    class="subscription-account-modal student-simulator-modal"
    width="80%"
    append-to-body
    :before-close="onCancel"
    :close-on-click-modal="false"
  >
    <!-- Cabecera personalizada del modal (Estilo Appmisionate) -->
    <template #header>
      <div class="student_modal_header">
        <div class="student_modal_header_icon">
          <i class="fas fa-laptop-code" />
        </div>
        <div class="student_modal_header_info">
          <h3 class="student_modal_title">
            Generar Simulación Personalizada
          </h3>
          <p class="student_modal_subtitle">
            Personaliza el nivel de dificultad, la gestión de tiempo y las materias para tu sesión de práctica
          </p>
        </div>
      </div>
    </template>

    <!-- Formulario principal estandarizado -->
    <el-form
      ref="formData"
      v-loading="conf.isLoading"
      :model="formData"
      :rules="rules"
      status-icon
      :label-position="'top'"
    >
      <!-- Sección 1: Parámetros Generales -->
      <div class="student_form_section">
        <div class="student_section_header">
          <h4 class="student_section_title">
            <i class="fas fa-sliders-h" /> Parámetros Generales
          </h4>
        </div>

        <!-- Fila 1: Nivel de Dificultad -->
        <el-form-item
          label="Nivel de Dificultad"
          prop="difficultyLevel"
        >
          <el-select
            v-model="formData.difficultyLevel"
            clearable
            filterable
            placeholder="Selecciona el nivel de dificultad para cargar las materias"
            value-key="id"
            class="w-100"
            @change="onChangeDifficultyLevel"
          >
            <el-option
              v-for="item in difficultyLevels"
              :key="item.id"
              :label="item.name"
              :value="item"
            />
          </el-select>
        </el-form-item>

        <!-- Fila 2: Modalidad de Tiempo (Tarjetas interactivas) -->
        <div class="mt-3">
          <label class="el-form-item__label mb-1">
            Modalidad de Tiempo
          </label>
          <div class="timer-mode-grid">
            <!-- Card 1: Sin Límite -->
            <div
              class="timer-mode-card"
              :class="{ active: currentTimerMode === 'none' }"
              @click="selectTimerMode('none')"
            >
              <div class="mode-card-header">
                <div class="mode-card-icon">
                  <i class="fas fa-infinity" />
                </div>
                <div class="mode-card-radio">
                  <span class="radio-dot" />
                </div>
              </div>
              <div class="mode-card-info">
                <span class="mode-card-title">Sin Límite</span>
                <span class="mode-card-desc">Práctica libre a tu propio ritmo</span>
              </div>
            </div>

            <!-- Card 2: Examen Completo -->
            <div
              class="timer-mode-card"
              :class="{ active: currentTimerMode === 'general' }"
              @click="selectTimerMode('general')"
            >
              <div class="mode-card-header">
                <div class="mode-card-icon">
                  <i class="fas fa-stopwatch" />
                </div>
                <div class="mode-card-radio">
                  <span class="radio-dot" />
                </div>
              </div>
              <div class="mode-card-info">
                <span class="mode-card-title">Examen Completo</span>
                <span class="mode-card-desc">Conteo regresivo para toda la prueba</span>
              </div>
            </div>

            <!-- Card 3: Por Sección -->
            <div
              class="timer-mode-card"
              :class="{ active: currentTimerMode === 'section' }"
              @click="selectTimerMode('section')"
            >
              <div class="mode-card-header">
                <div class="mode-card-icon">
                  <i class="fas fa-layer-group" />
                </div>
                <div class="mode-card-radio">
                  <span class="radio-dot" />
                </div>
              </div>
              <div class="mode-card-info">
                <span class="mode-card-title">Por Sección</span>
                <span class="mode-card-desc">Tiempo asignado por cada materia</span>
              </div>
            </div>

            <!-- Card 4: Por Pregunta -->
            <div
              class="timer-mode-card"
              :class="{ active: currentTimerMode === 'question' }"
              @click="selectTimerMode('question')"
            >
              <div class="mode-card-header">
                <div class="mode-card-icon">
                  <i class="fas fa-hourglass-half" />
                </div>
                <div class="mode-card-radio">
                  <span class="radio-dot" />
                </div>
              </div>
              <div class="mode-card-info">
                <span class="mode-card-title">Por Pregunta</span>
                <span class="mode-card-desc">Segundos específicos por cada reactivo</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Panel de Duración: Presets Rápidos + Stepper Ergonómico -->
        <div
          v-if="formData.isTimer"
          class="duration-config-panel"
        >
          <div class="duration-panel-header">
            <span class="duration-title">
              <i class="fas fa-clock" />
              {{ isTestTimeType ? 'Tiempo límite por reactivo' : (currentTimerMode === 'section' ? 'Tiempo límite por materia' : 'Tiempo total de la prueba') }}
            </span>
            <span class="duration-hint">
              {{ isTestTimeType ? 'Elige un atajo en segundos o ajusta libremente con los botones' : 'Elige una duración recomendada en minutos o ajusta con el contador' }}
            </span>
          </div>

          <div class="duration-controls-row">
            <!-- Chips de acceso rápido -->
            <div class="duration-presets">
              <button
                type="button"
                v-for="preset in currentPresets"
                :key="preset.value"
                class="duration-preset-chip"
                :class="{ active: formData.duration === preset.value }"
                @click="setDuration(preset.value)"
              >
                <span>{{ preset.label }}</span>
                <span
                  v-if="preset.tag"
                  class="preset-tag"
                >{{ preset.tag }}</span>
              </button>
            </div>

            <!-- Stepper numérico ergonómico -->
            <el-form-item
              prop="duration"
              class="mb-0"
            >
              <div class="stepper-composite">
                <button
                  type="button"
                  class="stepper-btn"
                  title="Disminuir tiempo"
                  :disabled="formData.duration <= 1"
                  @click="decrementDuration(5)"
                >
                  <i class="fas fa-minus" />
                </button>
                <div class="stepper-input-wrap">
                  <el-input-number
                    v-model="formData.duration"
                    :min="1"
                    :max="isTestTimeType ? 300 : 360"
                    :controls="false"
                    class="stepper-el-input"
                  />
                  <span class="stepper-unit">{{ isTestTimeType ? 'seg' : 'min' }}</span>
                </div>
                <button
                  type="button"
                  class="stepper-btn"
                  title="Aumentar tiempo"
                  :disabled="formData.duration >= (isTestTimeType ? 300 : 360)"
                  @click="incrementDuration(5)"
                >
                  <i class="fas fa-plus" />
                </button>
              </div>
            </el-form-item>
          </div>
        </div>
      </div>

      <!-- Sección 2: Secciones del Simulador -->
      <div class="student_form_section">
        <div class="student_section_header">
          <div class="section_title_wrap">
            <h4 class="student_section_title">
              <i class="fas fa-list-ol" /> Secciones y Cantidad de Preguntas
            </h4>
          </div>
          <el-button
            type="primary"
            class="btn_section_action"
            :disabled="!formData.difficultyLevel"
            @click="onAddSection()"
          >
            <i class="fas fa-plus mr-1" /> Agregar Sección
          </el-button>
        </div>

        <div class="student_table_wrap">
          <el-table
            v-if="formData.simulatorSections && formData.simulatorSections.length > 0"
            :data="formData.simulatorSections"
            style="width: 100%"
            class="student_careers_table student_simulator_table"
          >
            <el-table-column
              type="index"
              label="#"
              width="55"
              align="center"
            />
            <el-table-column
              label="Sección / Materia"
              min-width="260"
            >
              <template #default="scope">
                <el-form-item
                  :prop="'simulatorSections.' + scope.$index + '.simulatorQuestionCategory'"
                  :rules="{ validator: isSpecialtiesRequired }"
                  class="table-form-item mb-0"
                >
                  <el-select
                    v-model="scope.row.simulatorQuestionCategory"
                    clearable
                    filterable
                    placeholder="Selecciona una materia o sección"
                    value-key="id"
                    class="w-100"
                    @clear="onClearSimulatorQuestionCategory(scope.$index)"
                    @focus="onClickSimulatorQuestionCategory"
                    @change="onChangeSimulatorQuestionCategory(scope.row.simulatorQuestionCategory, scope.$index)"
                  >
                    <el-option
                      v-for="item in availebleCategories"
                      :key="item.id"
                      :label="item.name"
                      :value="item"
                    />
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
              label="Cantidad de Preguntas"
              width="210"
              align="center"
            >
              <template #default="scope">
                <el-form-item
                  :prop="'simulatorSections.' + scope.$index + '.questionQuantity'"
                  :rules="{ validator: onQuestionNumberValidator }"
                  class="table-form-item mb-0"
                >
                  <div class="table-stepper-box">
                    <div class="stepper-composite stepper-compact">
                      <button
                        type="button"
                        class="stepper-btn"
                        title="Disminuir reactivos"
                        :disabled="!scope.row.simulatorQuestionCategory || scope.row.questionQuantity <= 1"
                        @click="decrementQuestions(scope.row, 1)"
                      >
                        <i class="fas fa-minus" />
                      </button>
                      <div class="stepper-input-wrap">
                        <el-input-number
                          v-model="scope.row.questionQuantity"
                          :min="1"
                          :max="200"
                          :controls="false"
                          :disabled="!scope.row.simulatorQuestionCategory"
                          class="stepper-el-input"
                        />
                        <span class="stepper-unit">preg</span>
                      </div>
                      <button
                        type="button"
                        class="stepper-btn"
                        title="Aumentar reactivos"
                        :disabled="!scope.row.simulatorQuestionCategory || scope.row.questionQuantity >= 200"
                        @click="incrementQuestions(scope.row, 1)"
                      >
                        <i class="fas fa-plus" />
                      </button>
                    </div>

                    <!-- Chips de selección rápida de preguntas (10, 15, 20, 25) -->
                    <div
                      v-if="scope.row.simulatorQuestionCategory"
                      class="quick-question-chips"
                    >
                      <button
                        type="button"
                        v-for="qty in [10, 15, 20, 25]"
                        :key="qty"
                        class="chip-mini"
                        :class="{ active: scope.row.questionQuantity === qty }"
                        :title="`Asignar ${qty} preguntas`"
                        @click="setQuestionQuantity(scope.row, qty)"
                      >
                        {{ qty }}
                      </button>
                    </div>
                  </div>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
              label="Acción"
              width="90"
              align="center"
            >
              <template #default="scope">
                <el-button
                  type="danger"
                  link
                  size="small"
                  class="btn_delete_career"
                  title="Eliminar sección"
                  @click="onDeleteSection(scope.$index)"
                >
                  <i class="fas fa-trash-alt" />
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <div
            v-else
            class="student_empty_careers"
          >
            <i class="fas fa-info-circle mr-2" />
            <span v-if="!formData.difficultyLevel">
              Selecciona primero el <strong>Nivel de Dificultad</strong> para habilitar las materias y configurar tu prueba.
            </span>
            <span v-else>
              Aún no has agregado materias. Haz clic en <strong>"Agregar Sección"</strong> para comenzar a estructurar tu examen.
            </span>
          </div>
        </div>
      </div>
    </el-form>

    <!-- Footer del modal -->
    <template #footer>
      <div class="student_modal_footer">
        <span class="footer_note">
          <i class="fas fa-check-circle mr-1" />
          Los reactivos se seleccionarán de forma aleatoria del banco oficial
        </span>
        <div class="footer_actions">
          <el-button
            class="btn_cancel_student_modal"
            @click="onCancel"
          >
            Cancelar
          </el-button>
          <el-button
            type="primary"
            class="btn_submit_student_info"
            :loading="conf.isLoading"
            @click="onSubmitForm('formData')"
          >
            <i class="fas fa-play mr-2" /> Generar Simulador
          </el-button>
        </div>
      </div>
    </template>
  </el-dialog>
</template>
